function initScrollCinema() {
  if (typeof gsap === 'undefined') return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  if (typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
  }

  // Hero stats: cascade in on load, no scroll dependency (hero is above the fold).
  document.querySelectorAll('.hero-showcase__stats-grid').forEach((grid) => {
    const items = grid.querySelectorAll('.hero-showcase__stat-item');
    if (!items.length) return;
    gsap.from(items, {
      opacity: 0,
      y: 16,
      duration: 0.6,
      stagger: 0.12,
      delay: 0.3,
      ease: 'power2.out',
    });
  });

  if (typeof ScrollTrigger === 'undefined') return;

  // GPS feature list: staggered reveal as it scrolls into view.
  document.querySelectorAll('.gps-showcase__features').forEach((list) => {
    const items = list.querySelectorAll('.gps-showcase__feature');
    if (!items.length) return;
    gsap.from(items, {
      opacity: 0,
      x: -24,
      duration: 0.5,
      stagger: 0.12,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: list,
        start: 'top 80%',
        once: true,
      },
    });
  });

  // GPS phone: auto-cycles through the demo states once, when it scrolls into view.
  document.querySelectorAll('[data-gps-phone]').forEach((phone) => {
    const demo = phone.closest('.gps-showcase')
      ? phone.closest('.gps-showcase').querySelector('[data-gps-demo]')
      : null;

    ScrollTrigger.create({
      trigger: phone,
      start: 'top 65%',
      once: true,
      onEnter: () => {
        const lockBtn = demo ? demo.querySelector('[data-gps-action="lock"]') : null;
        const trackBtn = demo ? demo.querySelector('[data-gps-action="track"]') : null;

        const tl = gsap.timeline({ delay: 0.4 });
        tl.call(() => {
          phone.classList.add('is-locked');
          if (lockBtn) lockBtn.classList.add('is-active');
        })
          .to({}, { duration: 1.6 })
          .call(() => {
            phone.classList.remove('is-locked');
            if (lockBtn) lockBtn.classList.remove('is-active');
            phone.classList.add('is-tracking');
            if (trackBtn) trackBtn.classList.add('is-active');
          })
          .to({}, { duration: 1.6 })
          .call(() => {
            phone.classList.remove('is-tracking');
            if (trackBtn) trackBtn.classList.remove('is-active');
          });
      },
    });
  });

  // Bento advantage cards: staggered reveal by row.
  document.querySelectorAll('.advantages__grid').forEach((grid) => {
    const cards = grid.querySelectorAll('.advantages__card');
    if (!cards.length) return;
    gsap.from(cards, {
      opacity: 0,
      y: 24,
      duration: 0.5,
      stagger: 0.08,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: grid,
        start: 'top 85%',
        once: true,
      },
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollCinema);
} else {
  initScrollCinema();
}
